import styled from 'styled-components';

const PageSectionHeader = styled.div`
  font-size: 14px;
  margin: 5px 0;
  padding: 0;
  font-weight: 600;
  line-height: 1.3em;
  display: flex;
  div.invalid.error & {
    color: #ed1c24;
  }
  .summary-content & {
    font-weight: 600;
  }
`;

export default PageSectionHeader;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/PageSectionHeader/index.js